import { RowViewModel } from '../../../../lib/components/compound/table/viewModels/row';
import {
  StatusCellViewModel,
  NoteCellViewModel,
  BenefitCellViewModel,
  EmployeeNameCellViewModel,
  DateCellViewModel,
  UpdatedAtCellViewModel,
  AmountCellViewModel
} from '../cells';
import { ReceiptsViewModel } from '../../../../viewModels/receipts';
import { ReceiptsTableViewModel } from '../viewModel';
import { ActionsCellViewModel } from '../cells/actions/viewModel';

export class ReceiptsRowViewModel extends RowViewModel<ReceiptsViewModel, ReceiptsTableViewModel> {
  benefit: BenefitCellViewModel;
  employeeName: EmployeeNameCellViewModel;
  date: DateCellViewModel;
  updatedAt: UpdatedAtCellViewModel;
  amount: AmountCellViewModel;
  status: StatusCellViewModel;
  note: NoteCellViewModel;
  actions: ActionsCellViewModel;

  constructor(receipt: ReceiptsViewModel, table: ReceiptsTableViewModel) {
    super(receipt, table);
    this.benefit = new BenefitCellViewModel(this);
    this.employeeName = new EmployeeNameCellViewModel(this);
    this.date = new DateCellViewModel(this);
    this.updatedAt = new UpdatedAtCellViewModel(this);
    this.amount = new AmountCellViewModel(this);
    this.status = new StatusCellViewModel(this);
    this.note = new NoteCellViewModel(this);
    this.actions = new ActionsCellViewModel(this);
  }

  get id() {
    return this.entity.id;
  }

  get receipt() {
    return this.entity;
  }

  get translate() {
    return this.table.translate;
  }

  get navigate() {
    return this.table.navigate;
  }

  onRowDoubleClick() {
    this.receipt.openDetails();
  }
}
